// ChatGPT assigns sandbox origins per installation. Trust the HTTPS sandbox
// host family, not a particular tester; the one-use account handoff is still required.
export function isMcpHostOrigin(value: unknown, additionalOrigins: readonly string[] = []): boolean {
  if (typeof value !== 'string') return false;
  try {
    const url = new URL(value);
    if (url.origin !== value || url.protocol !== 'https:' || url.port || url.username || url.password) return false;
    return additionalOrigins.includes(value) ||
      url.hostname === 'web-sandbox.oaiusercontent.com' ||
      /^[a-z0-9-]+\.web-sandbox\.oaiusercontent\.com$/.test(url.hostname);
  } catch { return false; }
}
